import React from "react";
import { useTranslation } from "react-i18next";
import validator from "validator";

import { showError } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";

import FormLayout from "components/form/FormLayout";
import Sheet from "components/sheet/Sheet";
import TagInput from "components/tagInput/TagInput";
import Portal from "elements/Portal";

export interface IEMail {
  newEmail: string;
  emails: string[];
  invoiceID: number;
}

export type TRecipient = {
  id: number;
  start_time: string;
  division_id: number;
  course_id: number;
};

type TEmailModalProps = {
  state: { isOpen: boolean } & IEMail;
  customerEmail: string;
  update: (newState: IEMail) => void;
  close: () => void;
  onOk: () => void;
};

export default function EmailInvoiceModal(props: TEmailModalProps) {
  const { t } = useTranslation();
  const { state, update, close, onOk } = props;
  const dispatch = useAppDispatch();

  function handleAddNewEmail(event: KeyboardEvent) {
    if (event.key === "Enter" || event.key === ",") {
      const emails = state.emails.slice();
      const email = state.newEmail;

      if (!validator.isEmail(email)) {
        dispatch(showError(t("Please enter a valid email")));
        return;
      }

      emails.push(email);
      update({ ...state, emails: emails, newEmail: "" });
    }
  }

  function handleRemoveNewEmail(index: number) {
    const emails = state.emails.slice();
    emails.splice(index, 1);

    update({ ...state, emails: emails });
  }

  return (
    <Portal isMounted={state.isOpen}>
      <Sheet
        open={state.isOpen}
        size="small"
        closable
        cancelText={t("Close")}
        okText={t("Send Email")}
        title={t("Search Email")}
        okDisabled={state.emails.length === 0}
        onCancel={() => {
          close();
        }}
        onOk={onOk}
      >
        <FormLayout>
          <FormLayout.Group>
            <div>
              <div className="mt-4 mb-4">
                <TagInput
                  label={t("Add Email")}
                  value={state.newEmail}
                  onChange={e =>
                    update({ ...state, newEmail: e.target.value !== "," ? e.target.value : state.newEmail })
                  }
                  onKeyDown={handleAddNewEmail}
                  placeholder={t("Email")}
                  tags={state.emails}
                  onTagClick={(index: number) => handleRemoveNewEmail(index)}
                  helpText={t("Add an email tag with ' , ' or Enter.")}
                />
              </div>
            </div>
          </FormLayout.Group>
        </FormLayout>
      </Sheet>
    </Portal>
  );
}
